import React, { useEffect, useContext } from "react";
import { Switch, useRouteMatch } from "react-router-dom";

// Context Providers (change if you have recruitment specific states)
import { RecruitmentProvider } from "../../../context/states/recruitmentState";

// Recruitment Pages (Create these components if not already)
import { Recruitments } from "../../../components/pages/recruitments/Recruitments";
import EditRecruitment from "../../../components/pages/recruitments/Forms/EditRecruitment";

import AuthenticatedRoute from "../../../middlewares/AuthenticatedRoute";

const RecruitmentTracker = () => {
  let { path } = useRouteMatch();

  return (
    <React.Fragment>
      <RecruitmentProvider>
        <Switch>
          {/* Recruitment List */}
          <AuthenticatedRoute exact path={path}>
            <Recruitments title="Recruitment Tracker" />
          </AuthenticatedRoute>
          Edit Recruitment
          <AuthenticatedRoute
            permission="edit-recruitment"
            path={`${path}/edit/:id`}
          >
            <EditRecruitment />
          </AuthenticatedRoute>
        </Switch>
      </RecruitmentProvider>
    </React.Fragment>
  );
};

export default RecruitmentTracker;
